// extracted by mini-css-extract-plugin
export default {"projectCard":"accordion_projectCard__fXR+B","readBtn":"accordion_readBtn__fc+j-","column":"accordion_column__D9ONT","hr":"accordion_hr__m-cUk"};